"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.angleLookup = exports.handleDirection = exports.handleState = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var handleState = {
  PULL: 'pull',
  PUSH: 'push',
  BOTH: 'both'
};
exports.handleState = handleState;
var handleDirection = {
  RIGHT: 'right',
  DOWN: 'down',
  LEFT: 'left',
  UP: 'up'
};
exports.handleDirection = handleDirection;
var angleLookup = {
  right: 0,
  down: 90,
  left: 180,
  up: 270
};
exports.angleLookup = angleLookup;

var isHorizontal = function isHorizontal(direction) {
  return [handleDirection.LEFT, handleDirection.RIGHT].includes(direction);
};

var HandleContainer = _styledComponents["default"].div.withConfig({
  displayName: "Handle__HandleContainer",
  componentId: "sc-1gmz6nm-0"
})(function (props) {
  return (0, _styledComponents.css)(["display:flex;align-items:center;justify-content:center;flex:0 0 auto;", ""], isHorizontal(props.direction) ? (0, _styledComponents.css)(["width:34px;height:100%;"]) : (0, _styledComponents.css)(["width:100%;height:34px;"]));
});

var HandleSvg = _styledComponents["default"].svg.withConfig({
  displayName: "Handle__HandleSvg",
  componentId: "sc-1gmz6nm-1"
})(function (props) {
  return (0, _styledComponents.css)(["width:34px;height:192px;transform:rotate(", "deg);outline:none;cursor:", ";path{fill:", ";}path:nth-of-type(2){stroke:", ";fill:", ";stroke-linejoin:round;stroke-width:4px;}path:nth-of-type(1),path:nth-of-type(6){stroke:", ";stroke-width:1px;}:hover > path:nth-of-type(2){stroke:", ";}:focus > path:nth-of-type(2){stroke:", ";}", ";", ";"], angleLookup[props.direction], props.cursor ? props.cursor : isHorizontal(props.direction) ? 'col-resize' : 'row-resize', props.theme.color.action, props.theme.color.paper, props.theme.color.paper, props.theme.color.action, props.theme.color.hover, props.theme.color.focus, props.status === 'push' && (0, _styledComponents.css)(["path:nth-of-type(3){fill:transparent;}"]), props.status === 'pull' && (0, _styledComponents.css)(["path:nth-of-type(4){fill:transparent;}"]));
});
/**
  This component is simply a visual component that can be used to represent a handle on most draggable panels.
 */


var _ref2 = /*#__PURE__*/_react["default"].createElement("path", {
  d: "M16 0v74"
});

var _ref3 = /*#__PURE__*/_react["default"].createElement("path", {
  d: "M21.6 77.7L30.7 96 21 114.3l-1.5-.4C8.7 111 3 105 3 96c0-9 5.9-15 17-18l1.6-.3z"
});

var _ref4 = /*#__PURE__*/_react["default"].createElement("path", {
  d: "M18.5 93.3a1 1 0 000 1.4l1.3 1.3-1.3 1.3a1 1 0 001.5 1.4l2-2c.3-.4.3-1 0-1.4l-2-2a1 1 0 00-1.5 0z"
});

var _ref5 = /*#__PURE__*/_react["default"].createElement("path", {
  d: "M12 96.7a1 1 0 010-1.4l2-2a1 1 0 111.5 1.4L14.2 96l1.3 1.3a1 1 0 01-1.4 1.4l-2-2z"
});

var _ref6 = /*#__PURE__*/_react["default"].createElement("path", {
  d: "M27.1 96.4a1 1 0 000-.9l-7.5-15a1 1 0 111.8-1l8 16v1l-8.5 16a1 1 0 11-1.8-1l8-15z"
});

var _ref7 = /*#__PURE__*/_react["default"].createElement("path", {
  d: "M16 118v74"
});

var Handle = /*#__PURE__*/_react["default"].forwardRef(function Handle(_ref, ref) {
  var _ref$status = _ref.status,
      status = _ref$status === void 0 ? handleState.BOTH : _ref$status,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? handleDirection.RIGHT : _ref$direction,
      _ref$cursor = _ref.cursor,
      cursor = _ref$cursor === void 0 ? '' : _ref$cursor,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      _ref$onMouseDown = _ref.onMouseDown,
      onMouseDown = _ref$onMouseDown === void 0 ? function () {} : _ref$onMouseDown,
      _ref$onKeyDown = _ref.onKeyDown,
      onKeyDown = _ref$onKeyDown === void 0 ? function () {} : _ref$onKeyDown,
      _ref$onKeyUp = _ref.onKeyUp,
      onKeyUp = _ref$onKeyUp === void 0 ? function () {} : _ref$onKeyUp,
      _ref$onMouseUp = _ref.onMouseUp,
      onMouseUp = _ref$onMouseUp === void 0 ? function () {} : _ref$onMouseUp,
      _ref$onTouchMove = _ref.onTouchMove,
      onTouchMove = _ref$onTouchMove === void 0 ? function () {} : _ref$onTouchMove,
      _ref$onTouchEnd = _ref.onTouchEnd,
      onTouchEnd = _ref$onTouchEnd === void 0 ? function () {} : _ref$onTouchEnd;
  return /*#__PURE__*/_react["default"].createElement(HandleContainer, {
    ref: ref,
    direction: direction,
    onClick: onClick,
    onMouseDown: onMouseDown,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    onMouseUp: onMouseUp,
    onTouchMove: onTouchMove,
    onTouchEnd: onTouchEnd
  }, /*#__PURE__*/_react["default"].createElement(HandleSvg, {
    cursor: cursor,
    viewBox: "0 0 34 192",
    direction: direction,
    status: status,
    tabIndex: "0",
    role: "presentation"
  }, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7));
});

var _default = Handle;
exports["default"] = _default;